import { isSameFieldDatatype } from '../../../../expressions/datatype/Datatype.ts';
import { type IAsyncServiceParameter } from '../../../../expressions/repository/async/context/IAsyncService.ts';

export interface IAsyncServiceOutputsDiff {
  isStale: boolean;
  added: IAsyncServiceParameter[];
  removed: IAsyncServiceParameter[];
  changed: Array<{
    stored: IAsyncServiceParameter;
    current: IAsyncServiceParameter;
  }>;
}

/**
 * Funzione per confrontare i campi di output memorizzati di un servizio asincrono con quelli attuali,
 */
export function compareAsyncServiceOutputs(
  stored: IAsyncServiceParameter[] | undefined,
  current: IAsyncServiceParameter[],
): IAsyncServiceOutputsDiff {
  const storedList = stored ?? [];

  const storedByName = new Map(storedList.map(p => [p.name, p]));
  const currentByName = new Map(current.map(p => [p.name, p]));

  const added: IAsyncServiceParameter[] = [];
  const removed: IAsyncServiceParameter[] = [];
  const changed: IAsyncServiceOutputsDiff['changed'] = [];

  // Parametri presenti tra quelli attuali ma non in quelli memorizzati: sono stati aggiunti.
  for (const currentParam of current) {
    if (!storedByName.has(currentParam.name)) {
      added.push(currentParam);
    }
  }

  for (const storedParam of storedList) {
    const currentParam = currentByName.get(storedParam.name);
    if (!currentParam) {
      // Parametro memorizzato non più presente in quelli attuali: è stato rimosso.
      removed.push(storedParam);
    } else if (
      // Stesso nome ma tipo o sourcePath differenti: il parametro è cambiato.
      !isSameFieldDatatype(storedParam.type, currentParam.type) ||
      (storedParam.sourcePath ?? null) !== (currentParam.sourcePath ?? null)
    ) {
      changed.push({ stored: storedParam, current: currentParam });
    }
  }

  return {
    isStale: added.length > 0 || removed.length > 0 || changed.length > 0,
    added,
    removed,
    changed,
  };
}
